/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation LCRRoutePlanCreateMutation($input: [LCRRoutePlanCreateInput!]!) {
  LCRRoutePlanCreate(input: $input) {
    id,
    message,
    status
  }
}
`
